import { useState } from "react"
import { UploadFilesCard } from "../documentation/UploadFilesCard"
import { Button } from "../../ui/Button";
import { useParams } from "react-router-dom";
import { useSaveValidationFileFn } from "../../../hooks/react-query/useOffer";
import Loader from "../../elements/loader";
import { useToast } from "../../ui/Toast/useToast";

export const ContractDialog = () => {
    const [loading, setLoading] = useState(false);
    const [front, setFront] = useState({
        fileArray: [null],
        documentCodesToFriendlyNames: 'Μπροστά Όψη',
        maxFiles: 1,
        documentAllowedTypes: [
            "pdf",
            "tiff",
            "jfif",
            "gif",
            "bmp",
            "png",
            "jpeg",
            "jpg",
            "webp",
            "tif",
            "pjpeg",
            "avif"
        ]
    });
    const [back, setBack] = useState({
        fileArray: [null],
        documentCodesToFriendlyNames: 'Πίσω Όψη',
        maxFiles:1,
        documentAllowedTypes:[
            "pdf",
            "tiff",
            "jfif",
            "gif",
            "bmp",
            "png",
            "jpeg",
            "jpg",
            "webp",
            "tif",
            "pjpeg",
            "avif"
          ]
    });

    const { orderId } = useParams();

    const { toast } = useToast()

    const { mutate: validationFile } = useSaveValidationFileFn();

    const handleUploadDocuments = () => {
        let formData = new FormData();
        let jsonDataFront = "";
        let jsonDataBack = "";
        
        jsonDataFront = front.fileArray[0];
        jsonDataBack = back.fileArray[0];

        formData.set('verifyidfrontMimeType', jsonDataFront["type"].split('/')[1]);
        formData.set('verifyidbackMimeType', jsonDataBack["type"].split('/')[1]);
        formData.set('verifyidfront', front.fileArray[0]);
        formData.set('verifyidback', back.fileArray[0]);
        formData.set('cnCode', orderId);
        
        setLoading(true);
        validationFile({ cncode: orderId, data: formData }, {
            onSuccess: (data) => {
                setLoading(false);
                if (data.data.status === 'success') {
                    window.location.reload();
                } else {
                    toast({
                        title: "Απέτυχε",
                        description: "Ανεπιτυχής ταυτοποίηση χρήστη, προσπάθησε ξανά.",
                        variant:'destructive'
                      })
                }
            },
        })
    }

    return(
        <div className="flex flex-col items-center gap-6 pt-10">
            <p className="font-[700] text-[24px] pb-20">Ταυτοποίηση Χρήστη</p>
            <div className="grid grid-cols-2 w-full gap-6 lg:justify-between px-10 lg:pb-24">
                <UploadFilesCard className={'col-span-2 min-w-[25vw]'} titleClassName={'w-full'} key={0} onChange={(updatedArray,index)=>{setFront({...front, fileArray:updatedArray})}} uploadCase={front} />
                <UploadFilesCard className={'col-span-2 min-w-[25vw]'} titleClassName={'w-full'} key={1} onChange={(updatedArray,index)=>{setBack({...back, fileArray:updatedArray})}} uploadCase={back} />
            </div>
            <div className="w-full flex justify-center pb-10 pt-6 lg:border-t border-[#63636333]">
                <Button className={'disabled:bg-[#A5A5A5] bg-[#D4002A] px-16 py-2.5 rounded-[6px] text-white text-sm font-[600] max-lg:w-10/12'} 
                    disabled={front.fileArray[0] === null || back.fileArray[0] === null || loading}
                    onClick={handleUploadDocuments}>
                    {loading && <Loader />}
                    Υποβολή
                </Button>
            </div>
        </div>
    )
}